module.exports = __webpack_public_path__ + "static/media/Lato-BoldItalic.f98d1804.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Lato/Lato-BoldItalic.ttf
// module id = 297
// module chunks = 0